// eslint-disable-next-line no-unused-vars
import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';
import { useState } from 'preact/hooks';
import { exploreMenuPropType } from '../propTypes';
import ExplorePoster from './ExplorePoster';
import ExploreList from './ExploreList';
import MenuWrapper from './MenuWrapper';
import styled from '../utils/styled';
import ExploreSubMenuButton from './ExploreSubMenuButton';
import { mediaBreakpointDownMD } from '../../constants/style-constants';

const MenuListContainer = styled.div({
  /* stylelint-disable selector-type-case, selector-type-no-unknown */
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  [mediaBreakpointDownMD]: {
    marginBottom: '20px',
  },
});

const MenuContainer = styled.div({
  display: 'flex',
});

const ExploreMenu = ({
  exploreMenu: {
    items,
    subItems,
    subMenuButtonLabel,
    openSubMenuButtonLabel,
  },
  open,
  allowForSecondaryNav,
}) => {
  const [hoverItem, setHoverItem] = useState(null);
  const [subMenuShown, setSubMenuShown] = useState(false);

  const handleMouseLeave = () => setHoverItem(null);
  const handleOnHoverItem = item => setHoverItem(item);

  const toggleSubNav = () => setSubMenuShown(!subMenuShown);

  const subMenuItems = (subMenuShown ? subItems : []);

  if (items.length === 0) return null;

  return (
    <MenuWrapper id="nav-explore" open={open} topSpace={allowForSecondaryNav} flexDirection="column">
      <MenuContainer>
        <MenuListContainer>
          <ExploreList
            rootElementId="nav-explore-main-items-menu"
            items={items}
            onHoverItem={handleOnHoverItem}
            onMouseLeave={handleMouseLeave}
          />
          {subItems.length > 0 && (
            <Fragment>
              <ExploreSubMenuButton
                buttonLabel={subMenuButtonLabel}
                openButtonLabel={openSubMenuButtonLabel}
                open={subMenuShown}
                onClick={toggleSubNav}
              />
              <ExploreList
                rootElementId="nav-explore-sub-items-menu"
                items={subMenuItems}
                onHoverItem={handleOnHoverItem}
                onMouseLeave={handleMouseLeave}
              />
            </Fragment>
          )}
        </MenuListContainer>
        <ExplorePoster item={hoverItem} />
      </MenuContainer>
    </MenuWrapper>
  );
};

ExploreMenu.propTypes = {
  exploreMenu: exploreMenuPropType,
  open: PropTypes.bool.isRequired,
  allowForSecondaryNav: PropTypes.bool.isRequired,
};

ExploreMenu.defaultProps = {
  exploreMenu: {
    items: [],
    subItems: [],
  },
};

export default ExploreMenu;
